import React from 'react';

interface INewAPIModalProps {
    handleAPIModalClose: any;
    handleSelect: any;
}

const NewAPIModal: React.FC<INewAPIModalProps> = (props: INewAPIModalProps) => {
  const { handleAPIModalClose, handleSelect } = props;

  return (
    <div className='new-api-modal-paper'>
      <div className='new-api-modal-head'>
        <div className='api-icon-div'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
        <div className='api-modal-head-words'>
          <div className='api-modal-head-title'>
            <h1>Create API</h1>
            <svg onClick={handleAPIModalClose} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <h2>Please select which action you&apos;d like to take.</h2>
        </div>
      </div>
      <div className='new-api-modal-selections'>
        <div className='api-modal-selection-cont' onClick={() => handleSelect('connect')}>
          <div className='api-icon-div'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M12 4V15.2C12 16.8802 12 17.7202 12.327 18.362C12.6146 18.9265 13.0735 19.3854 13.638 19.673C14.2798 20 15.1198 20 16.8 20H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM7 4L17 4M7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4C3 2.89543 3.89543 2 5 2C6.10457 2 7 2.89543 7 4ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM12 12H17M17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <h1>New Automation API</h1>
          <h2>This allows you to put your external data into the BITE platform for Bulk searches.</h2>
        </div>
        <div className='api-modal-selection-cont' onClick={() => handleSelect('retrieve')}>
          <div className='api-icon-div'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 9.72021C21 11.3802 17 12.7202 12 12.7202C7 12.7202 3 11.3802 3 9.72021M21 14.44C21 16.1 17 17.44 12 17.44C7 17.44 3 16.1 3 14.44' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <h1>New Screening API</h1>
          <h2>This allows you to pull our internal data into your own platform.</h2>
        </div>
      </div>
      <div className='new-api-modal-btns'></div>
    </div>
  );
};

export default NewAPIModal;
